export const ingredients = [
    { value: 'all_purpose_flour', label: 'All purpose flour' },
    { value: 'allspice', label: 'Allspice' },
    { value: 'almond', label: 'Almond' },
    { value: 'almond_extract', label: 'Almond extract' },
    { value: 'almond_meal', label: 'Almond meal' },
    { value: 'anise', label: 'Anise' },
    { value: 'apple', label: 'Apple' },
    { value: 'apricot', label: 'Apricot' },
    { value: 'artichoke', label: 'Artichoke' },
    { value: 'arugula', label: 'Arugula' },
    { value: 'asparagus', label: 'Asparagus' },
    { value: 'aubergine', label: 'Aubergine' },
    { value: 'avocado', label: 'Avocado' },
    { value: 'avocado_oil', label: 'Avocado oil' },
    { value: 'baby_back_ribs', label: 'Baby back ribs' },
    { value: 'bacon', label: 'Bacon' },
    { value: 'banana', label: 'Banana' },
    { value: 'basil', label: 'Basil' },
    { value: 'bay_leaf', label: 'Bay leaf' },
    { value: 'bean_sprouts', label: 'Bean sprouts' },
    { value: 'beetroot', label: 'Beetroot' },
    { value: 'bell_pepper', label: 'Bell pepper' },
    { value: 'black_beans', label: 'Black beans' },
    { value: 'blackberry', label: 'Blackberry' },
    { value: 'blue_cheese', label: 'Blue cheese' },
    { value: 'blueberry', label: 'Blueberry' },
    { value: 'bok_choy', label: 'Bok choy' },
    { value: 'bread_flour', label: 'Bread flour' },
    { value: 'brie', label: 'Brie' },
    { value: 'broccoli', label: 'Broccoli' },
    { value: 'brown_rice', label: 'Brown rice' },
    { value: 'brussels_sprouts', label: 'Brussels sprouts' },
    { value: 'butter', label: 'Butter' },
    { value: 'buttermilk', label: 'Buttermilk' },
    { value: 'butternut_squash', label: 'Butternut squash' },
    { value: 'cabbage', label: 'Cabbage' },
    { value: 'cake_flour', label: 'Cake flour' },
    { value: 'caper', label: 'Caper' },
    { value: 'cardamom', label: 'Cardamom' },
    { value: 'carrot', label: 'Carrot' },
    { value: 'cauliflower', label: 'Cauliflower' },
    { value: 'cayenne_pepper', label: 'Cayenne pepper' },
    { value: 'celery', label: 'Celery' },
    { value: 'cheddar_cheese', label: 'Cheddar cheese' },
    { value: 'cheese', label: 'Cheese' },
    { value: 'cherry', label: 'Cherry' },
    { value: 'chia_seed', label: 'Chia seed' },
    { value: 'chicken', label: 'Chicken' },
    { value: 'chicken_breast', label: 'Chicken breast' },
    { value: 'chicken_thigh', label: 'Chicken thigh' },
    { value: 'chicken_wing', label: 'Chicken wing' },
    { value: 'chickpea_flour', label: 'Chickpea flour' },
    { value: 'chickpeas', label: 'Chickpeas' },
    { value: 'chives', label: 'Chives' },
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'cilantro', label: 'Cilantro' },
    { value: 'cinnamon', label: 'Cinnamon' },
    { value: 'clove', label: 'Clove' },
    { value: 'cocoa_powder', label: 'Cocoa powder' },
    { value: 'coconut', label: 'Coconut' },
    { value: 'coconut_oil', label: 'Coconut oil' },
    { value: 'coriander', label: 'Coriander' },
    { value: 'coriander_seed', label: 'Coriander seed' },
    { value: 'corn_flour', label: 'Corn flour' },
    { value: 'corn_kernel', label: 'Corn kernel' },
    { value: 'cornmeal', label: 'Cornmeal' },
    { value: 'cotija_cheese', label: 'Cotija cheese' },
    { value: 'courgette', label: 'Courgette' },
    { value: 'crab', label: 'Crab' },
    { value: 'cranberry', label: 'Cranberry' },
    { value: 'cream_cheese', label: 'Cream cheese' },
    { value: 'cucumber', label: 'Cucumber' },
    { value: 'cumin', label: 'Cumin' },
    { value: 'daikon', label: 'Daikon' },
    { value: 'dairy', label: 'Dairy' },
    { value: 'date', label: 'Date' },
    { value: 'dill', label: 'Dill' },
    { value: 'dutch_cocoa_powder', label: 'Dutch cocoa powder' },
    { value: 'eggplant', label: 'Eggplant' },
    { value: 'fennel', label: 'Fennel' },
    { value: 'fennel_seed', label: 'Fennel seed' },
    { value: 'fenugreek', label: 'Fenugreek' },
    { value: 'feta_cheese', label: 'Feta cheese' },
    { value: 'flank_steak', label: 'Flank steak' },
    { value: 'garam_masala', label: 'Garam masala' },
    { value: 'garlic', label: 'Garlic' },
    { value: 'ghee', label: 'Ghee' },
    { value: 'ginger', label: 'Ginger' },
    { value: 'goat_cheese', label: 'Goat cheese' },
    { value: 'grape', label: 'Grape' },
    { value: 'grapefruit', label: 'Grapefruit' },
    { value: 'green_beans', label: 'Green beans' },
    { value: 'ground_beef', label: 'Ground beef' },
    { value: 'habanero', label: 'Habanero' },
    { value: 'ham', label: 'Ham' },
    { value: 'jackfruit', label: 'Jackfruit' },
    { value: 'jalapeno', label: 'Jalapeño' },
    { value: 'kale', label: 'Kale' },
    { value: 'kidney_beans', label: 'Kidney beans' },
    { value: 'lavender', label: 'Lavender' },
    { value: 'leek', label: 'Leek' },
    { value: 'lemon', label: 'Lemon' },
    { value: 'lemongrass', label: 'Lemongrass' },
    { value: 'lentils', label: 'Lentils' },
    { value: 'lettuce', label: 'Lettuce' },
    { value: 'lime', label: 'Lime' },
    { value: 'liquid_smoke', label: 'Liquid smoke' },
    { value: 'mango', label: 'Mango' },
    { value: 'melon', label: 'Melon' },
    { value: 'mint', label: 'Mint' },
    { value: 'monterey_jack_cheese', label: 'Monterey jack cheese' },
    { value: 'mozzarella_cheese', label: 'Mozzarella cheese' },
    { value: 'mushrooms', label: 'Mushrooms' },
    { value: 'mustard', label: 'Mustard' },
    { value: 'nutmeg', label: 'Nutmeg' },
    { value: 'oat', label: 'Oat' },
    { value: 'oat_flour', label: 'Oat flour' },
    { value: 'olive', label: 'Olive' },
    { value: 'olive_oil', label: 'Olive oil' },
    { value: 'onion', label: 'Onion' },
    { value: 'orange', label: 'Orange' },
    { value: 'oregano', label: 'Oregano' },
    { value: 'oyster', label: 'Oyster' },
    { value: 'paprika', label: 'Paprika' },
    { value: 'parmesan_cheese', label: 'Parmesan cheese' },
    { value: 'parsley', label: 'Parsley' },
    { value: 'pea', label: 'Pea' },
    { value: 'peach', label: 'Peach' },
    { value: 'peanut', label: 'Peanut' },
    { value: 'peanut_butter', label: 'Peanut butter' },
    { value: 'peanuts', label: 'Peanuts' },
    { value: 'pear', label: 'Pear' },
    { value: 'peas', label: 'Peas' },
    { value: 'pecan', label: 'Pecan' },
    { value: 'pepper', label: 'Pepper' },
    { value: 'peppercorn', label: 'Peppercorn' },
    { value: 'peppermint', label: 'Peppermint' },
    { value: 'peppers', label: 'Peppers' },
    { value: 'pineapple', label: 'Pineapple' },
    { value: 'pinto_beans', label: 'Pinto beans' },
    { value: 'plantain', label: 'Plantain' },
    { value: 'plum', label: 'Plum' },
    { value: 'pomegranate', label: 'Pomegranate' },
    { value: 'poppy_seed', label: 'Poppy seed' },
    { value: 'pork', label: 'Pork' },
    { value: 'pork_belly', label: 'Pork belly' },
    { value: 'pork_chop', label: 'Pork chop' },
    { value: 'potato', label: 'Potato' },
    { value: 'prawns', label: 'Prawns' },
    { value: 'prosciutto', label: 'Prosciutto' },
    { value: 'provolone_cheese', label: 'Provolone cheese' },
    { value: 'pumpkin', label: 'Pumpkin' },
    { value: 'queso_fresco', label: 'Queso fresco' },
    { value: 'quinoa', label: 'Quinoa' },
    { value: 'radish', label: 'Radish' },
    { value: 'raisin', label: 'Raisin' },
    { value: 'raspberry', label: 'Raspberry' },
    { value: 'red_cabbage', label: 'Red cabbage' },
    { value: 'ricotta_cheese', label: 'Ricotta cheese' },
    { value: 'rose', label: 'Rose' },
    { value: 'rosemary', label: 'Rosemary' },
    { value: 'saffron', label: 'Saffron' },
    { value: 'sage', label: 'Sage' },
    { value: 'salami', label: 'Salami' },
    { value: 'salmon', label: 'Salmon' },
    { value: 'sausage', label: 'Sausage' },
    { value: 'scallion', label: 'Scallion' },
    { value: 'self_rising_flour', label: 'Self rising flour' },
    { value: 'sesame_oil', label: 'Sesame oil' },
    { value: 'sesame_seed', label: 'Sesame seed' },
    { value: 'shallot', label: 'Shallot' },
    { value: 'shrimp', label: 'Shrimp' },
    { value: 'sirloin_steak', label: 'Sirloin steak' },
    { value: 'skirt_steak', label: 'Skirt steak' },
    { value: 'sour_cream', label: 'Sour cream' },
    { value: 'spaghetti_squash', label: 'Spaghetti squash' },
    { value: 'spinach', label: 'Spinach' },
    { value: 'squash', label: 'Squash' },
    { value: 'sriracha_sauce', label: 'Sriracha sauce' },
    { value: 'star_anise', label: 'Star anise' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'sumac', label: 'Sumac' },
    { value: 'sweet_potato', label: 'Sweet potato' },
    { value: 'swiss_cheese', label: 'Swiss cheese' },
    { value: 'taco_seasoning', label: 'Taco seasoning' },
    { value: 'tamarind', label: 'Tamarind' },
    { value: 'tenderloin', label: 'Tenderloin' },
    { value: 'thyme', label: 'Thyme' },
    { value: 'tomato', label: 'Tomato' },
    { value: 'turkey', label: 'Turkey' },
    { value: 'turmeric', label: 'Turmeric' },
    { value: 'vanilla', label: 'Vanilla' },
    { value: 'vanilla_bean', label: 'Vanilla bean' },
    { value: 'vanilla_extract', label: 'Vanilla extract' },
    { value: 'watermelon', label: 'Watermelon' },
    { value: 'white_pepper', label: 'White pepper' },
    { value: 'whole_grain', label: 'Whole grain' },
    { value: 'zucchini', label: 'Zucchini' },
];

export const dietaryPreferences = [
    { value: 'vegetarian', label: 'Vegetarian' },
    { value: 'pescatarian', label: 'Pescatarian' },
    { value: 'kosher', label: 'Kosher' },
    { value: 'dairy_free', label: 'Dairy Free' },
    { value: 'vegan', label: 'Vegan' },
    { value: 'keto', label: 'Keto' },
    { value: 'alcohol_free', label: 'Alcohol Free' },
    { value: 'halal', label: 'Halal' },
    { value: 'gluten_free', label: 'Gluten Free' },
    { value: 'low_calorie', label: 'Low Calorie' },
    { value: 'high_fiber', label: 'High Fiber' },
    { value: 'high_protein', label: 'High Protein' },
    { value: 'low_sugar', label: 'Low Sugar' },
    { value: 'healthy', label: 'Healthy' },
    { value: 'low_carb', label: 'Low Carb' },
    { value: 'low_fat', label: 'Low Fat' },
];

export const cuisine = [
    { value: 'italian', label: 'Italian' },
    { value: 'thai', label: 'Thai' },
    { value: 'caribbean', label: 'Caribbean' },
    { value: 'filipino', label: 'Filipino' },
    { value: 'taiwanese', label: 'Taiwanese' },
    { value: 'swedish', label: 'Swedish' },
    { value: 'lebanese', label: 'Lebanese' },
    { value: 'asian', label: 'Asian' },
    { value: 'european', label: 'European' },
    { value: 'southern', label: 'Southern' },
    { value: 'mediterranean', label: 'Mediterranean' },
    { value: 'japanese', label: 'Japanese' },
    { value: 'korean', label: 'Korean' },
    { value: 'laotian', label: 'Laotian' },
    { value: 'cuban', label: 'Cuban' },
    { value: 'venezuelan', label: 'Venezuelan' },
    { value: 'brazilian', label: 'Brazilian' },
    { value: 'british', label: 'British' },
    { value: 'chinese', label: 'Chinese' },
    { value: 'german', label: 'German' },
    { value: 'indian', label: 'Indian' },
    { value: 'mexican', label: 'Mexican' },
    { value: 'hawaiian', label: 'Hawaiian' },
    { value: 'dominican', label: 'Dominican' },
    { value: 'puerto_rican', label: 'Puerto Rican' },
    { value: 'southwestern', label: 'Southwestern' },
    { value: 'north_american', label: 'North American' },
    { value: 'vietnamese', label: 'Vietnamese' },
    { value: 'african', label: 'African' },
    { value: 'kenyan', label: 'Kenyan' },
    { value: 'south_african', label: 'South African' },
    { value: 'haitian', label: 'Haitian' },
    { value: 'persian', label: 'Persian' },
    { value: 'jamaican', label: 'Jamaican' },
    { value: 'soul_food', label: 'Soul Food' },
    { value: 'jewish', label: 'Jewish' },
    { value: 'french', label: 'French' },
    { value: 'central_south_american', label: 'Central/South American' },
    { value: 'middle_eastern', label: 'Middle Eastern' },
    { value: 'fusion', label: 'Fusion' },
    { value: 'ethiopian', label: 'Ethiopian' },
    { value: 'west_african', label: 'West African' },
    { value: 'peruvian', label: 'Peruvian' },
    { value: 'indigenous_cuisine', label: 'Indigenous Cuisine' },
    { value: 'polish', label: 'Polish' },
];

export const cookingStyle = [
    { value: 'kid_friendly', label: 'Kid Friendly' },
    { value: 'big_batch', label: 'Big Batch' },
    { value: 'pan_fry', label: 'Pan Fry' },
    { value: 'deep_fry', label: 'Deep Fry' },
    { value: 'cooking_style', label: 'Cooking Style' },
    { value: 'comfort_food', label: 'Comfort Food' },
    { value: 'mashup', label: 'Mashup' },
    { value: 'no_bake_desserts', label: 'No Bake Desserts' },
    { value: 'steam', label: 'Steam' },
    { value: 'meal_prep', label: 'Meal Prep' },
    { value: 'stuffed', label: 'Stuffed' },
    { value: 'grill', label: 'Grill' },
    { value: 'one_pot_or_pan', label: 'One Pot or Pan' },
    { value: 'budget', label: 'Budget' },
];

export const appliances = [
    { value: 'blender', label: 'Blender' },
    { value: 'hand_mixer', label: 'Hand Mixer' },
    { value: 'microwave', label: 'Microwave' },
    { value: 'stove_top', label: 'Stove Top' },
    { value: 'air_fryer', label: 'Air Fryer' },
    { value: 'bread', label: 'Bread' },
    { value: 'baking', label: 'Baking' },
    { value: 'broiler', label: 'Broiler' },
    { value: 'cast_iron_pan', label: 'Cast Iron Pan' },
    { value: 'slow_cooker', label: 'Slow Cooker' },
    { value: 'wok', label: 'Wok' },
    { value: 'rolls', label: 'Rolls' },
    { value: 'dutch_oven', label: 'Dutch Oven' },
    { value: 'food_processor', label: 'Food Processor' },
    { value: 'appliance', label: 'Appliance' },
    { value: 'freezer_friendly', label: 'Freezer Friendly' },
    { value: 'bakery_goods', label: 'Bakery Goods' },
    { value: 'pressure_cooker', label: 'Pressure Cooker' },
];

export const mealType = [
    { value: 'appetizers', label: 'Appetizers' },
    { value: 'brunch', label: 'Brunch' },
    { value: 'desserts', label: 'Desserts' },
    { value: 'drinks', label: 'Drinks' },
    { value: 'breakfast', label: 'Breakfast' },
    { value: 'lunch', label: 'Lunch' },
    { value: 'dinner', label: 'Dinner' },
    { value: 'meal', label: 'Meal' },
];

export const difficulty = [
    { value: 'under_30_minutes', label: 'Under 30 Minutes' },
    { value: 'under_45_minutes', label: 'Under 45 Minutes' },
    { value: '5_ingredients_or_less', label: '5 Ingredients or Less' },
    { value: 'easy', label: 'Easy' },
    { value: 'under_1_hour', label: 'Under 1 Hour' },
    { value: 'under_15_minutes', label: 'Under 15 Minutes' },
];

export const seasonal = [
    { value: 'happy_hour', label: 'Happy Hour' },
    { value: 'indulgent_sweets', label: 'Indulgent Sweets' },
    { value: 'valentines_day', label: 'Valentine\'s Day' },
    { value: 'party', label: 'Party' },
    { value: 'passover', label: 'Passover' },
    { value: 'holidays', label: 'Holidays' },
    { value: 'occasion', label: 'Occasion' },
    { value: 'date_night', label: 'Date Night' },
    { value: 'special_occasion', label: 'Special Occasion' },
    { value: 'lunar_new_year', label: 'Lunar New Year' },
    { value: 'st_patrick_s_day', label: 'St. Patrick\'s Day' },
    { value: 'cinco_de_mayo', label: 'Cinco de Mayo' },
    { value: 'mothers_day', label: 'Mother\'s Day' },
    { value: 'picnic', label: 'Picnic' },
    { value: 'new_years', label: 'New Year\'s' },
    { value: '4th_of_july', label: '4th of July' },
];